// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Article_wrap__eE3Qp","label":"Article_label__QOfpd","value":"Article_value__JfEMf","icon":"Article_icon__qlWyt","ar":"Article_ar__e5SJm"};